<h1>Aprovar relatório de atividades</h1>

<mat-card>
  <mat-card-content fxLayout="column" fxLayoutGap="20px">
    <fieldset fxFlex="100%">
      <legend>Aluno</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput value="{{ relatorio?.nome }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput value="{{ relatorio?.cpf }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Programa</mat-label>
            <input matInput value="{{ relatorio?.programa }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Curso</mat-label>
            <input matInput value="{{ relatorio?.curso }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input matInput value="{{ relatorio?.campus }}" readonly="readonly" />
          </mat-form-field>
        </div>
      </form>
    </fieldset>

    <fieldset fxFlex="100%">
      <legend>Disciplina</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Disciplina</mat-label>
            <input matInput value="{{ relatorio?.nomeDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Código</mat-label>
            <input matInput value="{{ relatorio?.codigoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Semestre</mat-label>
            <input matInput value="{{ relatorio?.semestre }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Duração</mat-label>
            <input matInput value="{{ relatorio?.duracao }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Carga horária</mat-label>
            <input matInput value="{{ relatorio?.cargaHoraria }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Departamento</mat-label>
            <input matInput value="{{ relatorio?.departamentoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input
              matInput
              value="{{ relatorio?.campusDisciplina }} - {{ relatorio?.siglaDisciplina }}"
              readonly="readonly" />
          </mat-form-field>
        </div>
      </form>
    </fieldset>

    <fieldset fxFlex="100%">
      <legend>Relatório de atividades</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <div class="w100">
            <div class="w100-p14">
              <a class="w100-p7" mat-stroked-button (click)="download(relatorio)"
                ><mat-icon>file_download</mat-icon> Visualizar</a
              >
            </div>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>Situação</mat-label>
            <mat-select formControlName="aprovado" (selectionChange)="alteraSituacao($event)">
              <mat-option value="">Aguardando análise</mat-option>
              <mat-option value="apr">Aprovado</mat-option>
              <mat-option value="rep">Reprovado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" *ngIf="form.controls['aprovado'].value === 'rep'">
          <mat-label>Motivo</mat-label>
          <textarea matInput formControlName="motivo" rows="3"></textarea>
        </mat-form-field>
        @if (relatorio?.anoReferencia! >= 2025) {
          <mat-card class="info" style="margin-top: 0 !important;">
            <p>Atenção</p>
            <ul>
              <li>Informe o período de participação do discente no PAADES. Este período deve estar dentro do período de oferecimento da disciplina, conforme apresentado no Relatório de atividades.</li>
              <li>Esta informação constará no certificado. Sem ela, o discente não conseguirá emiti-lo.</li>
            </ul>
          </mat-card>
          <mat-form-field appearance="outline">
            <mat-label>Período de participação efetiva do discente</mat-label>
            <mat-icon class="danger" matPrefix (click)="clearDate()">close</mat-icon>
            <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
              <input readonly matStartDate formControlName="dataInicialAtividadesDiscente" />
              <input readonly matEndDate formControlName="dataFinalAtividadesDiscente" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        }
      </form>
    </fieldset>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayoutAlign="space-between center">
      <button mat-raised-button color="primary" (click)="gravar()"><mat-icon>save</mat-icon> Gravar</button>
      <button mat-stroked-button color="warn" routerLink="/docente/aprovar-relatorio-atividades">
        <mat-icon>close</mat-icon> Cancelar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
